export const setUpBillingPopupFields = [
  { title: 'cost_of_kwh_$', name: 'cost_of_kwh', hint: null },
  { title: 'payment_day', name: 'payment_day', hint: 'payment_day' },
]
